/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PopoverService, SearchModalComponent, UserMenuComponent} from '@pitagon/ngx-pids/components';
import {ConfigService} from '@pitagon/ngx-pids/config';
import {NavigationItem} from '@pitagon/ngx-pids/interfaces';
import {LayoutService, NavigationService} from '@pitagon/ngx-pids/services';
import {Observable, of} from 'rxjs';
import {map, startWith, switchMap} from 'rxjs/operators';
import {AuthenticationService} from "@pitagon/ngx-pids/security";

@Component({
  selector: 'ngx-pids-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  // @ts-ignore
  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  // @ts-ignore
  title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
  // @ts-ignore
  imageUrl$ = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  // @ts-ignore
  showCollapsePin$ = this.configService.config$.pipe(map(config => config.sidenav.showCollapsePin));
  // @ts-ignore
  userVisible$ = this.configService.config$.pipe(map(config => config.sidenav.user.visible));
  // @ts-ignore
  searchVisible$ = this.configService.config$.pipe(map(config => config.sidenav.search.visible));

  userMenuOpen$: Observable<boolean> = of(false);

  items: NavigationItem[] = this.navigationService.items;
  loggedInUserName: string;

  constructor(private navigationService: NavigationService,
              private layoutService: LayoutService,
              private configService: ConfigService,
              private readonly popoverService: PopoverService,
              private readonly dialog: MatDialog,
              private readonly authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.loggedInUserName = this.authenticationService.getUserName();
  }

  collapseOpenSidenav() {
    this.layoutService.collapseOpenSidenav();
  }

  collapseCloseSidenav() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
  }

  trackByRoute(index: number, item: any): string {
    return item.route;
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: UserMenuComponent,
        origin,
        offsetY: -8,
        width: origin.clientWidth,
        position: [
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSearch(): void {
    this.dialog.open(SearchModalComponent, {
      panelClass: 'ngx-pids-dialog-glossy',
      width: '100%',
      maxWidth: '600px'
    });
  }
}
